const masteryColors = [
  "#D3D3D3",
  "#ffeb3b",
  "#ffee58",
  "#66bb6a",
  "#e6ee9c",
  "#a5d6a7",
  "#81c784",
  "#43a047"
];

const projectBlue = "#4dd0e1"

export { masteryColors, projectBlue };
